import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { TextField, Grid, CircularProgress, Typography, Divider } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import { cutMaxLength } from 'utils/helpers'
import validate from 'validate.js'
import { useVestigioService } from 'hooks/useVestigioService'
import useRouter from 'utils/useRouter'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import { CustomButton } from 'components'

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    marginBottom: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const schema = {
  observacoes: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
}

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const Formulario = (props) => {
  const { className, carregando, idVestigio, ...rest } = props
  const vestigioService = useVestigioService()
  const classes = useStyles()
  const router = useRouter()
  const [processando, setProcessando] = useState(false)

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
  }, [formState.values])

  const handleChangeWithModification = (event, modification) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : modification(event.target.value),
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const hasError = (field) => formState.touched[field] && formState.errors[field]

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (formState.isValid) {
      await vestigioService.cancelarEncaminhamentoVestigio(idVestigio, formState.values.observacoes, setProcessando)
      router.history.push(`/casos/caso/vestigio/detalhar/${idVestigio}`)
    }
  }

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      {carregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <form id="form-encaminhar-vestigio-generico" onSubmit={handleSubmit} {...rest} className={clsx(classes.root, className)}>
          <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl
                style={{
                  minWidth: '100%',
                  maxWidth: '100%',
                }}
              >
                <TextField
                  error={hasError('observacoes')}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  helperText={hasError('observacoes') ? formState.errors.observacoes[0] : null}
                  label="MOTIVO DO CANCELAMENTO"
                  name="observacoes"
                  minRows={5}
                  onChange={(e) => handleChangeWithModification(e, maxLength250)}
                  value={formState.values.observacoes || ''}
                  multiline
                  required
                />
                <Typography variant="caption">Caracteres restantes: {250 - (formState.values.observacoes?.length ? formState.values.observacoes?.length : 0)}</Typography>
              </FormControl>
            </Grid>
          </Grid>

          <Divider style={{ margin: '20px 0' }} />

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', alignItems: 'center' }}>
            <CustomButton
              colorType="primary"
              variant="outlined"
              onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${idVestigio}`)}
              startIcon={<ArrowBackIcon />}
            >
              Voltar
            </CustomButton>
            <CustomButton
              colorType="error"
              type="submit"
              isDisabled={!formState.isValid || processando}
              isLoading={processando}
              startIcon={<CheckIcon />}
            >
              Confirmar Cancelamento
            </CustomButton>
          </div>
        </form>
      )}
    </div>
  )
}
